import Chart, { useChart } from 'src/components/chart';

// ----------------------------------------------------------------------

type Props = {
  chartRef?: any;
  series: number[];
  chartOptionsObj?: any;
  width?: any;
};

export default function ChartPie({ chartRef, series, width, chartOptionsObj }: Props) {
  const chartOptions = useChart({
    labels: ['Team A', 'Team B', 'Team C', 'Team D'],
    legend: {
      position: 'right',
      offsetX: -20,
      offsetY: 64,
      itemMargin: {
        vertical: 8,
      },
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      dropShadow: {
        enabled: false,
      },
    },
    tooltip: {
      fillSeriesColor: false,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    ...chartOptionsObj
  });

  return (
    <Chart ref={chartRef} dir="ltr" type="pie" series={series} options={chartOptions} width={width ?? 400} height="auto" />
  );
}
